import { toast } from 'react-toastify';

export function showToastMessageSuccess(msg) {
    const toastSuccess = toast.success(msg, {
        position: "top-right",
        className: 'toast-success-container toast-success-container-after'
    });

    return toastSuccess;
};

